import makeStyles from '@mui/styles/makeStyles'
import { alpha } from '@mui/material'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'unset',
    maxWidth: 'unset',
    height: 'unset',
    maxHeight: 'unset',
    borderColor: theme.palette.secondary.main,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main
  },

  emailRoot: {
    margin: '0',
    border: 'none',

    '&:hover': {
      border: 'none'
    },

    '& button': {
      width: 'fit-content',
      border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
      height: 'fit-content',
      padding: '0.25rem 0.5rem',
      color: theme.palette.primary.main,
      backgroundColor: 'transparent',

      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.2)
      }
    }
  },

  emailRootClass: {
    color: `${theme.palette.primary.main}`
  }
}))

export default useStyles
